import { Header } from 'components/Header'
import Footer from 'components/Footer'

const PageLayout = ({ children, viewer, loggedIn, hasFooter, hasUpgradeCta }) => (
  <>
    <Header loggedIn={loggedIn} viewer={viewer} showUpgradeCta={hasUpgradeCta} />
    <main>{children}</main>
    {hasFooter && <Footer />}
  </>
)

export default PageLayout
